<template>
  <div style="display: inline;">
    {{
      $nextTick(() => {
        // $refs.yt.list = $attrs.info;
      })
    }}
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getKey="rows" :columns="checkItem">
      <template #caozuo="scope">
        <!--        1新建,2待送货,3送货中,4部分收货,5全部收货,6部分上架,7全部上架-->
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.unreceiveQuantity > 0">
            <el-button
              type="text"
              @click="
                yt.showEditDialog('shouhuo', scope.row, 'w1');
                getStageAreaId();
              "
            >
              {{ $t('shouhuo') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.unlistedQuantity > 0 && (scope.row.detailStatus === '5' || scope.row.detailStatus === '6')">
            <el-button type="text" @click="receiving(scope.row)">
              {{ $t('shangjia') }}
            </el-button>
          </el-col>
          <!--          <el-col :span="0.1" v-if="scope.row.detailStatus === '4' || scope.row.detailStatus === '5'">-->
          <!--            <el-button type="text" @click="inspection(scope.row)">-->
          <!--              {{ $t('baojian') }}-->
          <!--            </el-button>-->
          <!--          </el-col>-->
        </el-row>
      </template>
    </yi_curd_table>
    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body" :destroy-on-close="true">
      <template v-if="yt.editObj.action == 'shouhuo'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('wuliaobianmamingcheng')" class="noborder">
              <el-input :value="yt.editObj.purchaseOrderDetail && yt.editObj.purchaseOrderDetail.material && yt.editObj.purchaseOrderDetail.material.name" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('wuliaopicihao')" class="noborder">
              <el-input v-model="yt.editObj.materialBatchNo" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('caigoudingdanhao')" class="noborder">
              <el-input v-model="yt.editObj.purchaseOrder.no" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('caigoudingdanhanghao')" class="noborder">
              <el-input v-model="yt.editObj.purchaseOrderDetail.no" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('dingdanshuliang')" class="noborder">
              <el-input v-model="yt.editObj.purchaseOrderDetail.quantity" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('caigoudanwei')" class="noborder">
              <el-input v-model="yt.editObj.purchaseOrderDetail.unit" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('bencisonghuoshuliang')" class="noborder">
              <el-input v-model="yt.editObj.deliveryQuantity" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('yishoushuliang')" class="noborder">
              <el-input v-model="yt.editObj.receiveQuantity" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('weishoushuliang')" class="noborder">
              <el-input v-model="yt.editObj.unreceiveQuantity" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('bencishishou')" required>
              <el-input-number class="inputClass" :precision="5" v-model="yt.editObj.thisReceiveQuantity"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('cangku/kuqu/kuwei')" required>
              <yi_data_select :key="'1'" :showAllLevels="true" :clearable="false" warehouseType="2" :multiple="false" :max="1" :checkStrictly="true" :warehouseLevel="2" :type="'warehouse'" :idsPathParent.sync="yt.editObj.idsPathParent" :ids.sync="yt.editObj.receiveLocation"> </yi_data_select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="takeDelivery(yt.editObj)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'shangjia'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('wuliaobianmamingcheng')" class="noborder">
              <el-input :value="yt.editObj.purchaseOrderDetail && yt.editObj.purchaseOrderDetail.material && yt.editObj.purchaseOrderDetail.material.name" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('wuliaopicihao')" class="noborder">
              <el-input v-model="yt.editObj.materialBatchNo" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('caigoudingdanhao')" class="noborder">
              <el-input v-model="yt.editObj.purchaseOrder.no" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('caigoudingdanhanghao')" class="noborder">
              <el-input v-model="yt.editObj.purchaseOrderDetail.no" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('dingdanshuliang')" class="noborder">
              <el-input v-model="yt.editObj.purchaseOrderDetail.quantity" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('caigoudanwei')" class="noborder">
              <el-input v-model="yt.editObj.purchaseOrderDetail.unit" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('yishoushuliang')" class="noborder">
              <el-input v-model="yt.editObj.receiveQuantity" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('weishangjiashuliang')" class="noborder">
              <el-input v-model="yt.editObj.unlistedQuantity" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('yishangjiashuliang')" class="noborder">
              <el-input v-model="yt.editObj.listedQuantity" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('bencishangjiashuliang')" required>
              <el-input-number class="inputClass" :precision="5" v-model="yt.editObj.thisListedQuantity"></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('cangku/kuqu/kuwei')" required>
              <yi_data_select :key="'1'" :showAllLevels="true" :clearable="false" :multiple="false" :max="1" :checkStrictly="true" :warehouseLevel="2" :type="'warehouse'" :idsPathParent.sync="yt.editObj.idsPathParent" :ids.sync="yt.editObj.listedLocation"> </yi_data_select>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="grounding(yt.editObj)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'checkDetail',
  data() {
    return {
      //  查看列
      checkItem: [
        {
          label: 'mingxizhuangtai',
          prop: 'detailStatus',
          type: 'dictionary_tag',
          key: 'ASN_DETAIL_STATUS',
          width: 150
        },
        {
          label: 'caigoudingdanhao',
          prop: 'purchaseOrder.no',
          width: 130
        },
        {
          label: 'caigoudingdanhanghao',
          prop: 'purchaseOrderDetail.no',
          width: 130
        },
        {
          label: 'wuliaobianmamingcheng',
          prop: 'purchaseOrderDetail.material.name',
          width: 130
        },
        {
          label: 'wuliaopicihao',
          prop: 'materialBatchNo',
          width: 130
        },
        {
          label: 'dingdanshuliang',
          prop: 'purchaseOrderDetail.quantity',
          width: 130
        },
        {
          label: 'caigoudanwei',
          prop: 'purchaseOrderDetail.unit'
        },
        {
          label: 'bencisonghuoshuliang',
          prop: 'deliveryQuantity',
          // type: 'slot',
          // wrap: true,
          width: 160
        },
        {
          label: 'yishoushuliang',
          prop: 'receiveQuantity',
          width: 160
        },
        {
          label: 'weishoushuliang',
          prop: 'unreceiveQuantity',
          width: 160
        },
        {
          label: 'shouhuokuwei',
          prop: 'receiveLocationName',
          width: 160
        },
        {
          label: 'yishangjiashuliang',
          prop: 'listedQuantity',
          width: 160
        },
        {
          label: 'weishangjiashuliang',
          prop: 'unlistedQuantity',
          width: 160
        },
        {
          label: 'shangjiakuwei',
          prop: 'listedLocationName',
          width: 160
        },
        {
          label: 'jianyanjieguo',
          prop: 'iqc.inspectionResult',
          type: 'dictionary_tag',
          key: 'TEST_RESULTS'
          // wrap: true,
        },
        {
          label: 'pandingjieguo',
          prop: 'iqc.judgmentResult',
          width: 150,
          type: 'dictionary_tag',
          key: 'JUDGMENT_RESULTS',
          wrap: true
        },
        // {
        //   label: 'tuihuoshuliang',
        //   prop: 'returnQuantity',
        //   width: 160
        // },
        {
          label: 'sehao',
          prop: 'colorNo',
          type: 'dictionary',
          key: 'CUSTOMER_MATERIAL_COLOR_NO',
          width: 160,
          show: false
        },
        {
          label: 'shengchanriqi',
          prop: 'productionDate',
          type: 'time',
          format: 'YYYY-MM-DD',
          width: 160
        },
        {
          label: 'shixiaoriqi',
          prop: 'expirationDate',
          type: 'time',
          format: 'YYYY-MM-DD',
          width: 160
        },
        {
          label: 'shouhuoriqi',
          prop: 'receiptDate',
          type: 'time',
          format: 'YYYY-MM-DD',
          width: 160
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 160
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          // wrap: true,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    // console.log('this.$attrs', this.$attrs.info);
    this.getAsnDetail();
    if (this.$attrs.colorNoEnable) {
      this.showCheckItem('sehao');
    }
  },
  methods: {
    // 显示 查看-销售订单明细 指定列
    showCheckItem(label) {
      for (let i = 0; i < this.checkItem.length; i++) {
        const c = this.checkItem[i];
        if (c.label === label) {
          c.show = true;
          break;
        }
      }
    },
    receiving(row) {
      //校验 IQC 检验单状态为已质检
      let purchaseOrderId = row.purchaseOrderId;
      this.http.get('/web/iqc/inspection/bill/page?pageNum=1&pageSize=10&purchaseOrderIds=' + purchaseOrderId).then(res => {
        if (res.data.total > 0) {
          //校验 IQC 检验单状态为已质检
          let data = res.data.rows[0];
          if (data.status == 2) {
            this.yt.showEditDialog('shangjia', row, 'w1');
          } else {
            this.utils.errorMessage(this.$t('qingwanchengjianyan'));
          }
        } else {
          this.yt.showEditDialog('shangjia', row, 'w1');
        }
      });
    },
    getAsnDetail() {
      return this.http
        .get('/web/supplier/asn/get?id=' + this.$attrs.id)
        .then(res => {
          this.$refs.yt.list = res.data.asnDetailList;
        })
        .catch(err => {
          this.utils.errorMessage(this.$t(err));
        });
    },

    //获取最早创建的暂存区的库区ID
    getStageAreaId() {
      let param = {
        type: 2
      };

      return this.http.get('/web/basic/warehouse/getStageAreaId?' + this.qs.stringify(param)).then(res => {
        this.$set(this.yt.editObj, 'receiveLocation', res.data);
      });
    },
    //收货
    takeDelivery(params) {
      console.log('params', this.$attrs.asn);
      let param = {
        ...params
      };

      this.http
        .post('/web/supplier/asn/detail/receipt/goods', param)
        .then(res => {
          this.yt.isShowEditDialog = false;
          this.getAsnDetail();
          // this.utils.event_hub.$emit('PURCHASING_ASN_REFRESH');
          // this.getPurchase();
        })
        .catch(err => {
          this.utils.errorMessage(this.$t(err));
        });
    },
    //上架
    grounding(params) {
      let param = {
        ...params
      };

      this.http
        .post('/web/supplier/asn/detail/on/shelves', param)
        .then(res => {
          this.yt.isShowEditDialog = false;
          this.getAsnDetail();
        })
        .catch(err => {
          this.utils.errorMessage(this.$t(err));
        });
    },
    getPurchase() {
      let paramsItem = {
        pageNum: 1,
        pageSize: 99,
        asnNo: this.$attrs.asn
      };
      return this.http
        .get('/web/supplier/asn/purchase/page?' + this.qs.stringify(paramsItem))
        .then(res => {
          const copiedB = res.data.rows;
          for (let i = 0; i < copiedB.length; i++) {
            for (let j = 0; j < this.$refs.yt.list.length; j++) {
              const list = copiedB[i]['asnDetailList'];
              for (let k = 0; k < list.length; k++) {
                if (this.$refs.yt.list[j]['id'] === list[i]['id']) {
                  this.$refs.yt.list = list;
                }
              }
            }
          }
          this.utils.successMessage(this.$t(res.msg));
        })
        .catch(err => {
          this.utils.errorMessage(this.$t(err));
        });
    },
    //报检
    inspection(row) {
      let param = {
        ...row
      };
      this.http
        .post('/web/supplier/asn/detail/inspection/report', param)
        .then(res => {
          this.getPurchase();
        })
        .catch(err => {
          this.utils.errorMessage(this.$t(err));
        });
    }
  }
};
</script>

<style scoped></style>
